import { BookingModalViewCalculation } from 'features/report-master/booking-calculation/components/modal/booking-calculation-modal';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
export const BookingCalculationDetailsView = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  if (!id) return null;

  const closeModal = () => {
    navigate(ROUTES.booking_calculation);
  };

  return (
    <BookingModalViewCalculation
      id={id}
      onClose={closeModal}
      onSuccess={closeModal}
    />
  );
};
